import { ajax } from 'cadenza/api-client/api';
import { MIMETYPE_JSON, PARAMETER_CONDITION_HASH } from 'cadenza/api-client/api-constants';
import { MapBasedConditionApi } from 'cadenza/api-client/conditions/map-based-condition-api';

export class MapConditionApi extends MapBasedConditionApi {

  getConditionSelectionFromFeatureSelection (featureIds) {
    return ajax(`${this.path}/features?${PARAMETER_CONDITION_HASH}=${this.conditionValuesSetHash}`, {
      type: 'POST',
      data: JSON.stringify(featureIds),
      contentType: MIMETYPE_JSON
    });
  }

}
